<script setup>
import PortalAuthShell from '@/Layouts/PortalAuthShell.vue'
</script>

<template>
  <PortalAuthShell portal="driver">
    <slot />
  </PortalAuthShell>
</template>
